"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventServiceV2Impl = void 0;
const events_1 = require("events");
const event_1 = require("../event");
class EventServiceV2Impl {
    constructor() {
        this.eventEmitter = new events_1.EventEmitter();
        this.userInfoUpdateEvent = new event_1.Event(this.eventEmitter, 'userinfo:update');
        this.vehicleAddEvent = new event_1.Event(this.eventEmitter, 'vehiclesection:add');
        this.vehicleDeleteEvent = new event_1.Event(this.eventEmitter, 'vehiclesection:delete');
        this.vehicleFavoriteEvent = new event_1.Event(this.eventEmitter, 'vehiclesection:favorite');
        this.vehiclePersonalDetailsEvent = new event_1.Event(this.eventEmitter, 'vehiclesection:personaldetails');
    }
    subscribeToUserInfoUpdate(listener) {
        return this.userInfoUpdateEvent.subscibe(listener);
    }
    announceUserInfoUpdate() {
        this.userInfoUpdateEvent.publish();
    }
    subscribeToVehicleAdd(listener) {
        return this.vehicleAddEvent.subscibe(listener);
    }
    announceVehicleAdd() {
        this.vehicleAddEvent.publish();
    }
    subscribeToVehicleDelete(listener) {
        return this.vehicleDeleteEvent.subscibe(listener);
    }
    announceVehicleDelete() {
        this.vehicleDeleteEvent.publish();
    }
    subscribeToVehicleFavorite(listener) {
        return this.vehicleFavoriteEvent.subscibe(listener);
    }
    announceVehicleFavorite() {
        this.vehicleFavoriteEvent.publish();
    }
    subscribeToVehiclePersonalDetails(listener) {
        return this.vehiclePersonalDetailsEvent.subscibe(listener);
    }
    announceVehiclePersonalDetails() {
        this.vehiclePersonalDetailsEvent.publish();
    }
}
exports.EventServiceV2Impl = EventServiceV2Impl;
//# sourceMappingURL=index.js.map